module.exports = __webpack_public_path__ + "img/6.0564f4b5.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":609,"height":356,"variants":[{"file":"img/6-480w.a49bad1699dd.webp","width":480},{"file":"img/6-609w.209f583e285a.webp","width":609}]};
}